/*=========================================================================================
  File Name: store.js
  Description: Vuex store
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Vuex from 'vuex'

import state from "./state"
import getters from "./getters"
import mutations from "./mutations"
import actions from "./actions"

import auth from './modules/auth'
import general from './modules/general'
import slips from './modules/slips'
import users from './modules/users'
import prospectClient from './modules/prospectClient'
import projetContrat from './modules/projetContrat'
import subscribe from './modules/suscribe'

Vue.use(Vuex)

export default new Vuex.Store({
    getters,
    mutations,
    state,
    actions,
    strict: process.env.NODE_ENV !== 'production',
    modules: {
      subscribe,
      auth,
      general,
      slips,
      prospectClient,
      projetContrat,
      users

    }
})
